import React, { useState, useEffect } from "react";
import Axios from "axios";
import useProgressiveImg from "../hooks/useProgressiveImg";
import { StarIcon, ViewIcon } from "@chakra-ui/icons";

const ScratchProject = ({ id, author, title, image, images, stats }) => {
  const [projectImgSrc, { blur: projectImageBlur }] = useProgressiveImg(
    images["100x80"],
    image
  );

  const [authorImageSrc, { blur: authorImageBlur }] = useProgressiveImg(
    author.profile.images["32x32"],
    author.profile.images["90x90"]
  );

  const openLink = () => {
    window.open(`https://scratch.mit.edu/projects/${id}`);
  };

  return (
    <div className="w-full">
      <div
        className="cursor-pointer flex flex-col h-full group rounded-md shadow hover:shadow-lg transition-all ease-out duration-500 transform hover:-translate-y-2"
        onClick={openLink}
      >
        <div className="w-full bg-gray-100" style={{ minHeight: "13rem" }}>
          <img
            className="rounded-t-md w-full"
            style={{
              filter: projectImageBlur ? "blur(5px)" : "none",
            }}
            src={projectImgSrc}
          />
        </div>

        <div className="flex items-center justify-start group-hover:bg-white transition-colors rounded-b-md bg-gray-50 flex-1">
          <div className="p-3 space-x-3 flex items-center">
            <img
              className="rounded-full w-8 h-8 shadow opacity-75 group-hover:opacity-100"
              style={{
                filter: authorImageBlur ? "blur(5px)" : "none",
              }}
              src={authorImageSrc}
            />

            <div>
              <p className="mt-px text-gray-400 group-hover:text-gray-500 text-sm">
                {author.username}
              </p>
              <p className="mb-2 font-semibold text-xl leading-none group-hover:text-black text-gray-800">
                {title}
              </p>
              <div className="space-x-3 flex items-center">
                <p className="leading-none font-bold text-red-200 group-hover:text-red-400 space-x-1 uppercase flex items-center text-xs">
                  <i
                    className="fas fa-heart"
                    style={{ fontSize: "0.65rem" }}
                  ></i>
                  <span>{stats.loves}</span>
                </p>
                <p className="leading-none font-bold text-yellow-300 group-hover:text-yellow-500 space-x-1 uppercase flex items-center text-xs">
                  <StarIcon w={3} h={3} />
                  <span>{stats.favorites}</span>
                </p>
                <p className="leading-none font-bold text-gray-300 group-hover:text-gray-500 space-x-1 uppercase flex items-center text-xs">
                  <ViewIcon w={3} h={3} />
                  <span>{stats.views}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScratchProject;
